import type { ReactNode } from 'react'

/** A borda e o espaçamento de um campo, num lugar só. */
const CAIXA = 'w-full rounded-lg border border-[var(--border)] bg-transparent px-2 py-1'

export function Campo({ label, children }: { label: string; children: ReactNode }) {
  return (
    <label className="block text-sm">
      <span className="mb-1 block text-[var(--text-muted)]">{label}</span>
      {children}
    </label>
  )
}

export function Texto({
  label,
  value,
  onChange,
  placeholder,
}: {
  label: string
  value: string
  onChange: (v: string) => void
  placeholder?: string
}) {
  return (
    <Campo label={label}>
      <input
        type="text"
        value={value}
        placeholder={placeholder}
        onChange={(e) => {
          onChange(e.target.value)
        }}
        className={CAIXA}
      />
    </Campo>
  )
}

export function TextoLongo({
  label,
  value,
  onChange,
  rows = 4,
  placeholder,
}: {
  label: string
  value: string
  onChange: (v: string) => void
  rows?: number
  placeholder?: string
}) {
  return (
    <Campo label={label}>
      <textarea
        value={value}
        rows={rows}
        placeholder={placeholder}
        onChange={(e) => {
          onChange(e.target.value)
        }}
        className={CAIXA}
      />
    </Campo>
  )
}

/**
 * Uma lista de frases, **uma por linha**, editada como texto corrido.
 *
 * A alternativa seria um campo por item com botões de somar e remover — três
 * cliques para escrever duas vantagens de um site. Aqui é digitar e apertar
 * Enter, que é como a pessoa já pensa a lista.
 *
 * A linha vazia é preservada **enquanto se digita** (senão apagar uma linha no
 * meio moveria o cursor) e some ao salvar, em `linhasDe`.
 */
export function Linhas({
  label,
  value,
  onChange,
  rows = 3,
  placeholder,
}: {
  label: string
  value: string[]
  onChange: (v: string[]) => void
  rows?: number
  placeholder?: string
}) {
  return (
    <TextoLongo
      label={label}
      value={value.join('\n')}
      rows={rows}
      placeholder={placeholder}
      onChange={(v) => {
        onChange(v.split('\n'))
      }}
    />
  )
}

/**
 * O botão de remover um item de uma lista de cartões.
 *
 * O `aria-label` diz **qual** item, porque a tela tem vários "Remover" iguais e
 * quem navega por leitor de tela ouviria a mesma palavra seis vezes seguidas.
 */
export function Remover({ oQue, onClick }: { oQue: string; onClick: () => void }) {
  return (
    <button
      type="button"
      aria-label={`Remover ${oQue}`}
      onClick={onClick}
      className="rounded-lg alvo px-2 py-1 text-sm text-[var(--text-muted)]"
    >
      Remover
    </button>
  )
}
